import { Component, Host, h, Prop, Element } from '@stencil/core';

@Component({
    tag: 'sew-ws-link-panels-2-item',
    styleUrl: 'sew-ws-link-panels-2-item.scss',
    shadow: true,
})
export class SewWsLinkPanels2Item {
    @Element() host: HTMLSewWsLinkPanels2ItemElement;

    @Prop() headline: string;
    @Prop() icon: string;

    private anchorEl: HTMLAnchorElement;

    componentDidLoad() {
        this.anchorEl = this.host.querySelector('a');

        if (this.anchorEl) {
            this.host.addEventListener('click', () => this.anchorEl.click());
        }
    }

    render() {
        return (
            <Host>
                <div class="content">
                    <div class="headline">{this.headline}</div>
                    <div class="icon-bg">
                        <sew-icon class="icon" size="xl" icon={this.icon} />
                    </div>
                </div>
                <slot></slot>
            </Host>
        );
    }
}
